import { render, staticRenderFns } from "./ActivixUpload.vue?vue&type=template&id=58bb1d60&"
import script from "./ActivixUpload.vue?vue&type=script&lang=js&"
export * from "./ActivixUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports